import React from 'react';
import { AnimatedSkeletonLoader } from '@usepepper/ui/atoms/animated-skeleton-loader';
import { useTheme } from '@/contexts/theme-context';
import { XStack, YStack } from '@usepepper/sprout-kit-ui';

const STAT_PLACEHOLDER_COUNT = 4;

/** Loading placeholder matching the order-entry item card's footprint. */
export const OrderEntryMobileCardSkeleton: React.FC = () => {
  const theme = useTheme();

  return (
    <YStack
      aria-hidden
      borderColor={theme.sk.color.border.primary}
      borderRadius={theme.sk.radii.radiusLarge}
      borderWidth={1}
      gap={theme.sk.spacing.spaceSMedium}
      padding={theme.sk.spacing.spaceMedium}
    >
      <XStack
        alignItems="flex-start"
        borderBottomColor={theme.sk.color.border.primary}
        borderBottomWidth={1}
        gap={theme.sk.spacing.spaceSMedium}
        paddingBottom={theme.sk.spacing.spaceSMedium}
      >
        <AnimatedSkeletonLoader
          borderRadius={theme.sk.radii.radiusMedium}
          height={48}
          width={48}
        />
        <YStack
          flex={1}
          gap={theme.sk.spacing.spaceSmall}
          minWidth={0}
          paddingTop={3}
        >
          <AnimatedSkeletonLoader
            borderRadius={theme.sk.radii.radiusMedium}
            height={14}
            width="80%"
          />
          <AnimatedSkeletonLoader
            borderRadius={theme.sk.radii.radiusMedium}
            height={12}
            width="45%"
          />
        </YStack>
      </XStack>

      <XStack gap={theme.sk.spacing.spaceSMedium} overflow="hidden">
        {Array.from({ length: STAT_PLACEHOLDER_COUNT }).map((_, index) => (
          <YStack flex={1} key={index}>
            <AnimatedSkeletonLoader
              borderRadius={theme.sk.radii.radiusMedium}
              height={14}
              width="100%"
            />
          </YStack>
        ))}
      </XStack>
    </YStack>
  );
};
